import { useTheme } from '../context/ThemeContext';

/**
 * Renders the correct logo based on the current theme:
 *  - Dark  mode  → /logo.png  (orange on dark background)
 *  - Light mode  → /logo-light.svg  (dark text + orange on light background)
 */
export default function LogoImg({ height = 36, style = {}, alt = 'Assistiv OS', className, forceDark = false, ...props }) {
  const { isDark } = useTheme();
  return (
    <img
      src={forceDark || isDark ? '/logo.png' : '/logo-light.webp'}
      alt={alt}
      style={{ height, width: 'auto', display: 'block', ...style }}
      className={className}
      {...props}
    />
  );
}
